export enum EFooterBlockType {
  Logo = 'logo',
  Images = 'images',
  Text = 'text',
  Links = 'links',
  Payments = 'payments',
}

export enum EFooterBlockOrientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export const FOOTER_BLOCK_TYPE_OPTIONS: {
  name: string;
  value: EFooterBlockType;
  icon: string;
}[] = [
  { name: 'Logo', value: EFooterBlockType.Logo, icon: 'image' },
  { name: 'Bild-Liste', value: EFooterBlockType.Images, icon: 'table_rows' },
  { name: 'Freitext', value: EFooterBlockType.Text, icon: 'text_fields' },
  { name: 'Link-Liste', value: EFooterBlockType.Links, icon: 'link' },
];

export type FooterAreaKey =
  | 'logoArea'
  | 'addressArea'
  | 'paymentArea'
  | 'linkArea';

export const DEFAULT_FOOTER_AREA_TYPE: Record<FooterAreaKey, EFooterBlockType> =
  {
    logoArea: EFooterBlockType.Logo,
    addressArea: EFooterBlockType.Text,
    paymentArea: EFooterBlockType.Payments,
    linkArea: EFooterBlockType.Links,
  };

export function toFooterBlockType(
  type: string | undefined,
  fallback: EFooterBlockType
): EFooterBlockType {
  if (type === 'logo' || type === EFooterBlockType.Logo) {
    return EFooterBlockType.Logo;
  }

  if (
    type === EFooterBlockType.Images ||
    type === EFooterBlockType.Text ||
    type === EFooterBlockType.Links ||
    type === EFooterBlockType.Payments
  ) {
    return type;
  }

  return fallback;
}
